module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "title-div"
  }, [_vm._v(_vm._s(_vm.$t('all.duanyingyin')))]), _vm._v(" "), _c('div', {
    staticClass: "fabu",
    on: {
      "click": _vm.handleShowModal
    }
  }, [_vm._v(_vm._s(_vm.$t('all.fabuduanyingyin')))])]), _vm._v(" "), (_vm.videoList.length > 0) ? _c('div', {
    staticClass: "duanyingyin-list"
  }, _vm._l((_vm.videoList), function(item, index) {
    return _c('div', {
      key: item.id || index,
      staticClass: "video-item",
      on: {
        "click": function($event) {
          return _vm.handlePlayVideo(item)
        }
      }
    }, [_c('img', {
      staticClass: "video-item-img",
      attrs: {
        "src": _vm.getItemCover(item)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "video-item-content"
    }, [_c('span', {
      staticClass: "video-item-content-span"
    }, [_vm._v(_vm._s(item.title || ''))]), _vm._v(" "), _c('span', {
      staticClass: "video-item-content-span1"
    }, [_vm._v(_vm._s(item.duration ? _vm.formatDuration(item.duration) : '00:00'))])]), _vm._v(" "), _c('img', {
      staticClass: "video-item-del",
      attrs: {
        "src": require("../../assets/image/shanchu_18@2x.png"),
        "alt": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleDeleteVideo(item)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "video-item-status"
    }, [_vm._v(_vm._s(item.status === 0 ? _vm.$t('all.shenhezhong') : item.status === 2 ? _vm.$t('all.shenhejujue') : ''))])])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.loaded && _vm.videoList.length === 0) ? _c('kong') : _vm._e(), _vm._v(" "), (_vm.isModalVisible) ? _c('div', {
    staticClass: "modal-overlay",
    on: {
      "click": function($event) {
        _vm.isModalVisible = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-content",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('all.fabuduanyingyin')))]), _vm._v(" "), _c('div', {
    staticClass: "modal-input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.title),
      expression: "form.title"
    }],
    staticClass: "modal-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('all.qingshurubiaoti')
    },
    domProps: {
      "value": (_vm.form.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-upload-box",
    on: {
      "click": _vm.handleUploadClick
    }
  }, [(!_vm.form.videoUrl) ? _c('div', {
    staticClass: "modal-upload-content"
  }, [_c('span', {
    staticClass: "modal-upload-text"
  }, [_vm._v(_vm._s(_vm.$t('all.shangchuanduanyingyin')))])]) : _c('div', {
    staticClass: "modal-video-preview"
  }, [_c('video', {
    staticClass: "modal-video",
    attrs: {
      "src": _vm.form.videoUrl,
      "controls": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "modal-video-name"
  }, [_vm._v(_vm._s(_vm.form.videoName))])])]), _vm._v(" "), (_vm.uploading) ? _c('div', {
    staticClass: "modal-progress-box"
  }, [_c('div', {
    staticClass: "modal-progress-bar"
  }, [_c('div', {
    staticClass: "modal-progress-fill",
    style: ({
      width: _vm.uploadProgress + '%'
    })
  })]), _vm._v(" "), _c('span', {
    staticClass: "modal-progress-text"
  }, [_vm._v(_vm._s(_vm.uploadProgress.toFixed(1)) + "%")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-btn",
    class: {
      disabled: !_vm.form.title || !_vm.form.videoUrl || _vm.uploading
    },
    on: {
      "click": _vm.handlePublish
    }
  }, [_vm._v("发布")]), _vm._v(" "), _c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "video/*"
    },
    on: {
      "change": _vm.handleFileChange
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.showPlayer) ? _c('div', {
    staticClass: "player-overlay",
    on: {
      "click": _vm.closePlayer
    }
  }, [_c('div', {
    staticClass: "player-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "player-close",
    on: {
      "click": _vm.closePlayer
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "player-video-wrap"
  }, [_c('video', {
    ref: "playerVideo",
    staticClass: "player-video",
    attrs: {
      "src": _vm.playerUrl
    },
    on: {
      "timeupdate": _vm.onPlayerTimeUpdate,
      "loadedmetadata": _vm.onPlayerMetadata,
      "ended": _vm.onPlayerEnded
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "player-controls"
  }, [_c('div', {
    staticClass: "player-controls-btn",
    on: {
      "click": _vm.togglePlayerPlay
    }
  }, [(_vm.playerPlaying) ? _c('span', [_vm._v("❚❚")]) : _c('span', [_vm._v("▶")])]), _vm._v(" "), _c('span', {
    staticClass: "player-controls-time"
  }, [_vm._v(_vm._s(_vm.formatTime(_vm.playerCurrentTime)))]), _vm._v(" "), _c('div', {
    ref: "playerProgressBar",
    staticClass: "player-controls-progress",
    on: {
      "click": _vm.seekPlayer,
      "mousedown": _vm.onPlayerProgressMouseDown
    }
  }, [_c('div', {
    staticClass: "player-controls-progress-bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "player-controls-progress-fill",
    style: ({
      width: _vm.playerProgress + '%'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "player-controls-progress-dot",
    style: ({
      left: _vm.playerProgress + '%'
    })
  })]), _vm._v(" "), _c('span', {
    staticClass: "player-controls-time"
  }, [_vm._v(_vm._s(_vm.formatTime(_vm.playerDuration)))]), _vm._v(" "), _c('div', {
    staticClass: "player-controls-speed",
    on: {
      "click": _vm.togglePlayerSpeed
    }
  }, [_vm._v(_vm._s(_vm.$t('all.beisu')) + " x" + _vm._s(_vm.playerSpeed))])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c35159e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/duanyingyin/duanyingyin.vue
// module id = 950
// module chunks = 1